module.exports = __webpack_public_path__ + "static/media/ic_searchtype_marina.1cf3edd7.svg";